import { Component, Input } from "@angular/core";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { DataResponse, PreviewItem } from "@apiserver-rest/ponder-data-client-base";
import { PreviewItemContextMenuComponet } from "../preview-item-context-menu.component";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { take } from "rxjs";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

@Component({
    selector: "preview-item-context-set-avatar",
    imports: [],
    templateUrl: "./preview-item-context-menu-set-avatar.component.html"
})
export class PreviewItemContextMenuSetAvatar {
    @Input({ required: true }) parentRef!: PreviewItemContextMenuComponet;
    @Input({ required: true }) previewItem!: PreviewItem;

    public readonly svgIcon: string = SvgIconMap.get(SvgIcon.Profile)!;

    public constructor(private ponderDataClient: PonderDataClient, private events: EventBroker) {

    }

    public onClick(): void {
        this.ponderDataClient
            .userAvatar(this.previewItem.id!)
            .pipe(take(1))
            .subscribe({
                next: (response: DataResponse) => {
                    if (response.success) {
                        this.events.profile.profileAvatarUpdatedEvent.emit();
                    }
                }
            });

        this.parentRef.onClose();
    }
}